import { FoodBurger } from '@creditornot/cb-icons';
import React from 'react';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useLocaleUtils } from 'common/hooks';
import { Typography } from 'common/typography';
import { useCampaignModuleContext } from 'modules/campaigns/context';
import { ItemDiscountType } from 'modules/campaigns/types';

export const useItemDiscountTypes = (isEndOfDayCampaign?: boolean) => {
  const { currency } = useCampaignModuleContext();
  const { formatMessage, locale } = useIntl();
  const { getCurrencySymbol } = useLocaleUtils();

  return useMemo(() => {
    const symbol = getCurrencySymbol(currency);
    return [
      {
        title: formatMessage({ id: 'campaigns.item-discount-type.options.x-for-free.title' }),
        description: formatMessage({ id: 'campaigns.item-discount-type.options.x-for-free.description' }),
        icon: <FoodBurger />,
        type: ItemDiscountType.X_FOR_FREE,
      },
      {
        title: formatMessage({ id: 'campaigns.item-discount-type.options.percentage-off.title' }),
        description: formatMessage({
          id: isEndOfDayCampaign
            ? 'campaigns.item-discount-type.options.percentage-off.end-of-day-description'
            : 'campaigns.item-discount-type.options.percentage-off.description',
        }),
        icon: <Typography.Heading4>%</Typography.Heading4>,
        type: ItemDiscountType.PERCENTAGE_OFF,
      },
      {
        title: formatMessage({ id: 'campaigns.item-discount-type.options.amount-off.title' }, { symbol }),
        description: formatMessage(
          {
            id: isEndOfDayCampaign
              ? 'campaigns.item-discount-type.options.amount-off.end-of-day-description'
              : 'campaigns.item-discount-type.options.amount-off.description',
          },
          {
            amount: (5).toLocaleString(locale, {
              style: 'currency',
              minimumFractionDigits: 0,
              currency,
            }),
          },
        ),
        icon: <Typography.Heading4>{symbol}</Typography.Heading4>,
        type: ItemDiscountType.AMOUNT_OFF,
      },
    ];
  }, [currency, formatMessage, getCurrencySymbol, isEndOfDayCampaign, locale]);
};
